import find from 'lodash/find';
import each from 'lodash/each';
import pick from 'lodash/pick';
import includes from 'lodash/includes';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import mapValues from 'lodash/mapValues';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import cloneDeep from 'lodash/cloneDeep';
import { sha256 } from 'js-sha256';
import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import User from 'yoda-site-components/lib/helpers/User/User';
import { isSentToAgencyFromCart } from '../helpers/Utils/Utils';
import {
    ADJUSTMENT_TYPE_FREE_SHIP,
    ANALYTICS_PAGE_INFO_CART,
    ANALYTICS_PAGE_INFO_PAGE_TYPE_CHECKOUT,
    ANALYTICS_PAGE_INFO_PAGE_TYPE_CART,
    ANALYTICS_BEST_COUPON,
    ANALYTICS_OVERSIZESURCHARGE,
    ANALYTICS_PAGE_NAME_CHECKOUT_PAYMENT,
    ANALYTICS_PAGE_NAME_CHECKOUT_SHIPPING,
    ANALYTICS_PAGE_NAME_CHECKOUT_SHOPPING_CART,
    ANALYTICS_PAGE_NAME_CHECKOUT_SAME_DAY_PICKUP,
    ANALYTICS_VERSION_REVIEW,
    ANALYTICS_VERSION_CHECKOUT_SIGN,
    ANALYTICS_VERSION_PAYMENT,
    ANALYTICS_VERSION_SDPU,
    ANALYTICS_VERSION_SHIPPING,
    ANALYTICS_VERSION_GC_BALANCE,
    ANALYTICS_VERSION_SINGLE_CLICK_CHECKOUT,
    ANALYTICS_VERSION_CART,
    ANALYTICS_VERSION_EMPTY_CART,
    ANALYTICS_VERSION_OCP,
    ANALYTICS_SHIPPING_METHOD,
    ANALYTICS_PAGE_INFO_CHECKOUT,
    ANALYTICS_BOF,
    ANALYTICS_SUBTOTAL_AFTER_ADJUSTMENT,
    ANALYTICS_PAYMENTS_VERIFIED,
    ANALYTICS_PAYMENTS_JCPMASTER_VAL,
    ANALYTICS_PAYMENTS_JCPMASTER,
    ANALYTICS_PAYMENTS_JCP,
    ANALYTICS_PAYMENTS_VISA,
    ANALYTICS_PAYMENTS_DISCOVER,
    ANALYTICS_PAYMENTS_JCPGIFTCARD,
    ANALYTICS_PAYMENTS_APPLEPAY,
    ANALYTICS_PAYMENTS_MASTERCARD,
    ANALYTICS_PAYMENTS_MASTER,
    ANALYTICS_PAYMENTS_AMEX_KEY,
    ANALYTICS_PAYMENTS_AMEX,
    ANALYTICS_PAYMENTS_CC,
    ANALYTICS_PAYMENTS_PAYPAL,
    ANALYTICS_TAX,
    ANALYTICS_ROUNDUP,
    ANALYTICS_EVENTS,
    ANALYTICS_ORDERAMOUNT,
    ANALYTICS_PAGE_TYPE_ACCOUNT,
    ANALYTICS_PAGE_TYPE_SHOPPING_CART,
    ANALYTICS_PAGE_TYPE_CHECKOUT,
    ANALYTICS_ACTIONS_CART_ADD,
    ANALYTICS_ACTIONS_CAPTCHA_ERROR,
    ANALYTICS_ACTIONS_DELETE_CARD_AT_CHECKOUT,
    ANALYTICS_ACTIONS_EDIT_CARD_AT_CHECKOUT,
    ANALYTICS_ACTIONS_LOGIN_FAILED,
    ANALYTICS_ACTIONS_LOGIN_ATTEMPTED,
    ANALYTICS_ACTIONS_PRODUCT_CO_OOS,
    ANALYTICS_ACTIONS_COUPON_REMOVED,
    ANALYTICS_ACTIONS_EXPEDITED_CHECKOUT,
    ANALYTICS_ACTIONS_EXPRESS_CHECKOUT,
    ANALYTICS_ACTIONS_SAME_DAY_PICKUP,
    ANALYTICS_ACTIONS_SELECT_STORE_SUCCESS,
    ANALYTICS_ACTIONS_COUPON_APPLIED_SUCCESS,
    ANALYTICS_ACTIONS_LINK_REWARDS_ACCOUNT,
    ANALYTICS_ACTIONS_CREATE_ACCOUNT,
    ANALYTICS_ACTIONS_MOVE_TO_CART,
    ANALYTICS_ACTIONS_SAVE_FOR_LATER,
    ANALYTICS_ACTIONS_OPTIONAL_SERVICE_ADD_CART,
    ANALYTICS_ACTIONS_OPTIONAL_SERVICE_UPDATE_CART,
    ANALYTICS_ACTIONS_OPTIONAL_SERVICE_REMOVE_CART,
    ANALYTICS_ACTIONS_INTERSTITIAL_UPDATE_CART,
    ANALYTICS_ACTIONS_REMOVE_ITEM,
    ANALYTICS_ACTIONS_UPDATE_CART,
    ANALYTICS_REWARDSCERT,
    ANALYTICS_SHIPPING_TYPE_EXPRESS,
    ANALYTICS_SHIPPING_TYPE_EXPRESS_ECONOMY,
    ANALYTICS_SHIPPING_TYPE_GROUND3DAY,
    ANALYTICS_CHECKOUT_BTN_POSN_NONSTICKY,
    ANALYTICS_CHECKOUT_BTN_POSN_STICKY,
    ANALYTICS_FREE,
    ANALYTICS_YES,
    ANALYTICS_COUPON,
    ANALYTICS_FAIL,
    ANALYTICS_COUPON_DISCOUNT,
    ANALYTICS_NO,
    ANALYTICS_SHIPPING_AND_HANDLING,
    ANALYTICS_SUB_TOTAL,
    ANALYTICS_CO_PROCESS_TYPE_PAYPAL_EXPRESS,
    ANALYTICS_CO_PROCESS_TYPE_SINGLE_CLICK,
    ANALYTICS_CO_PROCESS_TYPE_APPLE_PAY,
    ANALYTICS_CO_PROCESS_TYPE_PAYPAL,
    ANALYTICS_CO_PROCESS_TYPE_EXPEDITED,
    ANALYTICS_CO_PROCESS_TYPE_EXPRESS,
    ANALYTICS_CO_PROCESS_TYPE_REGISTERED,
    ANALYTICS_CO_PROCESS_TYPE_GUEST,
    ANALYTICS_EMPTY,
    ANALYTICS_ASSOCIATEDISCOUNT,
    ANALYTICS_RECYCLE,
    ANALYTICS_ZERO,
} from '../common/Constants';
import { getURLParameterBykey, isAurora, isOOSItem } from '../helpers/Utils/ATCCommonUtils';
import productHelper from './DigitalAnalyticsHelper';

let updateCommonDigitalData;
let getURLParameterUsingkey;

const createProduct = (
    orderDetails,
    productDLType,
    qtyChangedItems,
    isDesktop,
    clickPositionName
) => {
    const items = orderDetails.bag && orderDetails.bag.items ? orderDetails.bag.items : undefined;
    if (isUndefined(items)) {
        return {};
    }
    const params = {
        orderDeliveryGroups:
            orderDetails.delivery && orderDetails.delivery.groups
                ? orderDetails.delivery.groups
                : {},
        qtyChangedItems,
        okToDifferenciateSTS: false,
    };
    const productInfoMapper = (item, isChild = false) => {
        switch (productDLType) {
            case 'sameDayPickup':
                return {
                    ...productHelper.minimalObjFactory(item),
                    ...productHelper.handleBopisIncentivesInCart(item, 'bopisFulfilmentChange'),
                };
            case 'cartAdd':
                return {
                    ...productHelper.fullObjFactory(item, params),
                    clickPosition: productHelper.productClickPosition(clickPositionName),
                };

            case 'insterstitalCartUpdate':
                return productHelper.mediumObjFactory(item, params);
            case 'checkout payment':
            case 'checkout review':
                params.okToDifferenciateSTS = true;
                return productHelper.fullObjFactory(item, params);
            case 'checkout order confirmation':
                params.okToDifferenciateSTS = true;
                return {
                    productFee: productHelper.productFee(item), // <== only needed for OCP
                    productImageSRC: item.product.imageURL
                        ? item.product.imageURL
                        : ANALYTICS_EMPTY, // <== only needed for OCP
                    productAssociateDiscount: item.adjustments
                        ? productHelper.findValueByKey(item.adjustments, {
                              code: ANALYTICS_ASSOCIATEDISCOUNT,
                          })
                        : ANALYTICS_ZERO, // <== only needed for OCP

                    ...productHelper.fitPredictorAttributes(
                        orderDetails.fitPredictorAttributesData,
                        item
                    ),
                    ...productHelper.fullObjFactory(item, params),
                    ...productHelper.getBopisIncentivesInPlacedOrder(item),
                    ...productHelper.prodPromiseDate(item, isChild), // <== only needed for OCP
                };
            default:
                return {
                    ...productHelper.fullObjFactory(item, params),
                    ...productHelper.handleBopisIncentivesInCart(item, 'bopisIncentiveItem', true),
                };
        }
    };

    const productInfoArray = [];

    each(items, (item) => {
        const product = { productInfo: productInfoMapper(item, false) };
        if (productDLType === 'insterstitalCartUpdate') {
            product.productInfo.productEstimatedDelivery = productHelper.productEstimatedDelivery(
                item.deliveryOptions
            );
        }
        product.productInfo.productCartAddLocation = item.source || '';
        // Additional Adobe attributes
        const adobeAttrMap = {
            brandName: 'productBrandName',
            categoryName: 'productCategoryName',
            division: 'productDivisionID',
            entity: 'productEntity',
            primaryBarCode: 'productPrimaryBarcode',
            subDivision: 'productSubdivision',
        };
        (item.analyticsAttributes || []).forEach((attr) => {
            const prodReqAttr = adobeAttrMap[attr.type];
            if (prodReqAttr) {
                product.productInfo[prodReqAttr] = attr.value;
            }
        });

        productInfoArray.push(product);
        each(item.childItems, (childItem) => {
            const modifyChildItems = childItem;
            if (modifyChildItems.type !== ANALYTICS_RECYCLE) {
                modifyChildItems.quantity = modifyChildItems.sku.quantity;
                const childItemBasedProduct = {
                    productInfo: productInfoMapper(modifyChildItems, true),
                };
                childItemBasedProduct.productInfo.productPPID = product.productInfo.productPPID;
                productInfoArray.push(childItemBasedProduct);
            }
        });
    });
    return productInfoArray;
};

const createCartAttributes = (orderDetails, isCart, orderApplepayEligible) => {
    if (isEmpty(orderDetails.totals)) {
        return {};
    }

    const getDeliveryGroups =
        orderDetails.delivery &&
        orderDetails.delivery.groups &&
        orderDetails.delivery.groups.length > 0
            ? orderDetails.delivery.groups
            : undefined;

    const findCartTotal = (totals) => {
        const merchandiseSubTotal = find(totals, { type: ANALYTICS_SUB_TOTAL });
        return merchandiseSubTotal && merchandiseSubTotal.amount
            ? merchandiseSubTotal.amount.toFixed(2)
            : ANALYTICS_ZERO;
    };

    const cartAttributes = {
        cartTotal: findCartTotal(orderDetails.totals),
        deviceApplePayEligible: productHelper.findApplePayEligible(orderApplepayEligible),
    };

    if (isCart) {
        const shippingCost = find(orderDetails.charges, { type: ANALYTICS_SHIPPING_AND_HANDLING });
        cartAttributes.estShippingCost =
            shippingCost && isNumber(shippingCost.amount)
                ? Number(shippingCost.amount).toFixed(2)
                : ANALYTICS_ZERO;
    }

    /* istanbul ignore else */
    if (!__SERVER__ && window) {
        cartAttributes.shoppingBagNumber =
            orderDetails.id || getURLParameterUsingkey('OrderId') || ANALYTICS_EMPTY;
    }

    // preeShippingOffered attribute logic
    if (getDeliveryGroups) {
        const getHomeGroup = find(getDeliveryGroups, { type: 'HOME' });
        /* istanbul ignore else */
        if (
            getHomeGroup &&
            getHomeGroup.serviceLevels &&
            getHomeGroup.serviceLevels.data.length > 0
        ) {
            const findPremiumCode = find(getHomeGroup.serviceLevels.data, {
                code: ANALYTICS_SHIPPING_TYPE_GROUND3DAY,
            });
            const findExpressEconCode = find(getHomeGroup.serviceLevels.data, {
                code: ANALYTICS_SHIPPING_TYPE_EXPRESS_ECONOMY,
            });
            const findExpressCode = find(getHomeGroup.serviceLevels.data, {
                code: ANALYTICS_SHIPPING_TYPE_EXPRESS,
            });
            if (findPremiumCode || findExpressCode || findExpressEconCode) {
                cartAttributes.preeShippingOffered = ANALYTICS_YES;
            } else {
                cartAttributes.preeShippingOffered = ANALYTICS_NO;
            }
        }
    }

    const checkoutBtnStatus = LocalStorage.getData('analyticsCheckoutButton');
    /* istanbul ignore next */
    if (!isEmpty(checkoutBtnStatus)) {
        cartAttributes.checkoutInitiatePosition = checkoutBtnStatus.isStickyUsed
            ? ANALYTICS_CHECKOUT_BTN_POSN_STICKY
            : ANALYTICS_CHECKOUT_BTN_POSN_NONSTICKY;
        LocalStorage.removeData('analyticsCheckoutButton');
    }
    return cartAttributes;
};

const updateCartAttributWithPlccBanner = (cartAttributes, plccBanner) => {
    if (!isEmpty(plccBanner) && plccBanner.displayPlccBanner) {
        // eslint-disable-next-line no-param-reassign
        cartAttributes.plccBannerExist = 'yes';
        // eslint-disable-next-line no-param-reassign
        cartAttributes.plccBannerName = productHelper.getPlccBannerName(plccBanner);
    } else {
        // eslint-disable-next-line no-param-reassign
        cartAttributes.plccBannerExist = 'no';
    }
};

const addSingleClickCheckout = (cartAttributes, orderDataAvailable, context) => {
    const { enableSingleClickCheckout = true } = context?.featureFlags || {};
    const singleClickEligible = get(orderDataAvailable, 'status.singleClickEligible', false);
    if (singleClickEligible && enableSingleClickCheckout) {
        // eslint-disable-next-line no-param-reassign
        cartAttributes.scCheckout = 'yes';
    }
};

const getCheckoutProcessType = (orderDetails, commonDigitalData, sccValue) => {
    // initialize the default value to 'guest'
    let checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_GUEST;

    if (
        commonDigitalData &&
        commonDigitalData.user &&
        commonDigitalData.user.profile &&
        commonDigitalData.user.profile.profileInfo &&
        commonDigitalData.user.profile.profileInfo.customerState &&
        User.isUserLoggedIn()
    ) {
        // if user is logged in checkoutProcessType = standard
        checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_REGISTERED;
    }

    /* istanbul ignore else */
    if (orderDetails) {
        if (orderDetails.analyticsAttributes) {
            const expediteCO = find(orderDetails.analyticsAttributes, {
                type: 'expediteCheckoutEligible',
            });
            const expressCO = find(orderDetails.analyticsAttributes, {
                type: 'expressCheckoutEligible',
            });
            const checkoutPath = find(orderDetails.analyticsAttributes, { type: 'CheckoutPath' });
            // we are relying on the values available in analyticsAttributes to determine
            // if the checkout process was expedited or express.
            expressCO &&
                expressCO.value === 'true' &&
                (checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_EXPRESS);
            expediteCO &&
                expediteCO.value === 'true' &&
                (checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_EXPEDITED);
            checkoutPath &&
                checkoutPath.value === 'PayPal' &&
                (checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_PAYPAL);
        }
        // billing details not there for Sent to agency client
        if (!isSentToAgencyFromCart()) {
            const { billing } = orderDetails;
            if (
                billing.creditCards &&
                billing.creditCards.cards &&
                billing.creditCards.cards.length > 0 &&
                !isEmpty(billing.creditCards.cards[0].applePay)
            ) {
                checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_APPLE_PAY;
            }
        }

        const singleClickCheckout = getURLParameterBykey('scc', window.location.href);
        if (singleClickCheckout || sccValue) {
            checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_SINGLE_CLICK;
        }
    }

    return checkoutProcessType;
};

const getCartDiscount = (analyticsAttributes) => {
    const discountAmount = productHelper.analyticsAttributesMapper(
        analyticsAttributes,
        ANALYTICS_COUPON_DISCOUNT
    );
    return discountAmount && Number(discountAmount).toFixed(2);
};

const createCardRewards = (orderDetails) => {
    const applyMethod = (adjustment) => {
        const lastTouchedAdjustment = LocalStorage.getData('lastTouchedAdjustment');
        let method = ANALYTICS_EMPTY;
        if (lastTouchedAdjustment && adjustment.id === lastTouchedAdjustment.id) {
            method = lastTouchedAdjustment.method;
        }
        return method;
    };
    if (isEmpty(orderDetails.adjustments)) {
        return productHelper.couponRewardsInfoDLSkeleton();
    }

    const negativeAmountCheck = (adjustment) => {
        if (adjustment.code === ANALYTICS_COUPON) {
            if (adjustment.amount < 0) {
                return ANALYTICS_FREE;
            }
            return Number(adjustment.amount).toFixed(2);
        }
        return Number(adjustment.amount).toFixed(2);
    };

    const couponRewardData = [];

    each(orderDetails.adjustments, (adjustment) => {
        if (adjustment.code === ANALYTICS_ASSOCIATEDISCOUNT) {
            return;
        }

        let isReward = false;
        if (adjustment.code === ANALYTICS_REWARDSCERT) {
            isReward = true;
        }
        const couponRewardItem = {};

        if (isReward) {
            couponRewardItem.couponCode = ANALYTICS_EMPTY;
            couponRewardItem.couponEligible = ANALYTICS_EMPTY;
            couponRewardItem.couponType = ANALYTICS_EMPTY;
            couponRewardItem.couponDiscount = ANALYTICS_EMPTY;
            couponRewardItem.couponAmount = ANALYTICS_EMPTY;
            couponRewardItem.couponApplyMethod = ANALYTICS_EMPTY;
            couponRewardItem.rewardRedemptionID = adjustment.value || ANALYTICS_EMPTY;
            couponRewardItem.rewardValid = adjustment.amount ? ANALYTICS_YES : ANALYTICS_NO;
            couponRewardItem.rewardType = adjustment.description
                ? adjustment.description.toLowerCase()
                : ANALYTICS_EMPTY;
            couponRewardItem.rewardAmount = adjustment.amount
                ? Number(adjustment.amount).toFixed(2)
                : ANALYTICS_ZERO;
            couponRewardItem.rewardApplyMethod = applyMethod(adjustment);
        } else {
            couponRewardItem.couponCode = adjustment.value
                ? adjustment.value.toLowerCase()
                : ANALYTICS_EMPTY;
            couponRewardItem.couponEligible = adjustment.amount ? ANALYTICS_YES : ANALYTICS_NO;
            couponRewardItem.couponType = adjustment.description
                ? adjustment.description.toLowerCase()
                : ANALYTICS_EMPTY;
            couponRewardItem.couponDiscount =
                adjustment.description !== ADJUSTMENT_TYPE_FREE_SHIP
                    ? getCartDiscount(orderDetails.analyticsAttributes)
                    : ANALYTICS_EMPTY;
            couponRewardItem.couponAmount = adjustment.amount
                ? negativeAmountCheck(adjustment)
                : ANALYTICS_ZERO;
            couponRewardItem.couponApplyMethod = applyMethod(adjustment);
            couponRewardItem.rewardRedemptionID = ANALYTICS_EMPTY;
            couponRewardItem.rewardValid = ANALYTICS_EMPTY;
            couponRewardItem.rewardType = ANALYTICS_EMPTY;
            couponRewardItem.rewardAmount = ANALYTICS_EMPTY;
            couponRewardItem.rewardApplyMethod = ANALYTICS_EMPTY;
        }

        couponRewardData.push(couponRewardItem);
    });

    return couponRewardData;
};

const createShippingAddress = (orderDetails) => {
    let address = '';
    if (
        orderDetails.delivery &&
        orderDetails.delivery.groups &&
        orderDetails.delivery.groups.length > 0
    ) {
        address = orderDetails.delivery.groups[0].address;
    }
    if (!address) {
        return {};
    }
    const formatter = (val) => {
        if (isString(val)) {
            return val.toLowerCase();
        }
        /* istanbul ignore else */
        if (isNumber(val)) {
            return String(val);
        }
        return val;
    };
    const shippingValues = pick(address, ['city', 'state', 'zip', 'country']);
    return mapValues(shippingValues, formatter);
};

const createTransactionAttributes = (orderDetails) => {
    // transaction id will be blank for Send to agency order
    const orderDetailsNumber = !isSentToAgencyFromCart() ? orderDetails.number : ANALYTICS_EMPTY;
    const transactionAttributes = {
        paymentType: [],
        ccType: ANALYTICS_EMPTY,
        transactionID: orderDetailsNumber || ANALYTICS_EMPTY,
        transactionApproved: ANALYTICS_NO,
        shippingMethod: ANALYTICS_EMPTY,
        bundleFlag: ANALYTICS_NO,
        isTestOrder: orderDetails.isTestOrder ? 'yes' : 'no',
    };

    const { groups } = orderDetails.delivery;
    const itemAmountObj = [];
    if (orderDetails.bag && orderDetails.bag.items && orderDetails.bag.items.length > 0) {
        forEach(orderDetails.bag.items, (itemTotal) => {
            const itemAmount = find(itemTotal.totals, { name: 'ITEM AMOUNT' });
            itemAmountObj.push(itemAmount);
        });
    }

    const { billing } = orderDetails;
    if (!isSentToAgencyFromCart()) {
        if (!billing) {
            return transactionAttributes;
        }

        // 1) paymentType = paypal | creditcard | jcp gift card | apple pay | apple pay|paylater
        // 2) ccType = jcp | visa | mastercard | paypal | discover | american express | paylater
        if (billing.paypal) {
            transactionAttributes.paymentType.push(ANALYTICS_PAYMENTS_PAYPAL);
            transactionAttributes.ccType = ANALYTICS_PAYMENTS_PAYPAL;
        }

        if (billing.creditCards.cards.length > 0) {
            transactionAttributes.paymentType.push(ANALYTICS_PAYMENTS_CC);
            const creditCard = billing.creditCards.cards[0];
            let cardType = creditCard.type.toLowerCase();
            if (creditCard?.subtype === 'BNPL_SYF') {
                cardType = 'paylater';
            }
            const promoFinancingAccepted = get(creditCard, 'financing.options[0].selected', false);
            if (promoFinancingAccepted) {
                transactionAttributes.promoFinancingAccepted = 'yes';
            }
            switch (cardType) {
                case ANALYTICS_PAYMENTS_AMEX_KEY:
                    transactionAttributes.ccType = ANALYTICS_PAYMENTS_AMEX;
                    break;

                case ANALYTICS_PAYMENTS_MASTER:
                    transactionAttributes.ccType = ANALYTICS_PAYMENTS_MASTERCARD;
                    break;

                case ANALYTICS_PAYMENTS_JCPMASTER:
                    transactionAttributes.ccType = ANALYTICS_PAYMENTS_JCPMASTER_VAL;
                    break;

                default:
                    transactionAttributes.ccType = cardType;
                    break;
            }
        }

        const paymentApplePayType = get(billing, 'creditCards.cards[0].applePay');
        if (!isEmpty(paymentApplePayType)) {
            const isBnplOnOrder = billing?.creditCards?.cards?.[0]?.subtype === 'BNPL_SYF';
            const bnplWithApplePay = isBnplOnOrder ? '|paylater' : '';
            transactionAttributes.paymentType = [
                `${ANALYTICS_PAYMENTS_APPLEPAY}${bnplWithApplePay}`,
            ];
        }

        if (billing.unnamed && billing.unnamed.giftCards && !isEmpty(billing.unnamed.giftCards)) {
            transactionAttributes.paymentType.push(ANALYTICS_PAYMENTS_JCPGIFTCARD);
        }

        // 3) paymentStatus
        let paymentStatus;
        switch (transactionAttributes.ccType) {
            case ANALYTICS_PAYMENTS_PAYPAL:
                paymentStatus = billing.paypal.status;
                break;

            case ANALYTICS_PAYMENTS_JCP:
            case ANALYTICS_PAYMENTS_VISA:
            case ANALYTICS_PAYMENTS_MASTERCARD:
            case ANALYTICS_PAYMENTS_DISCOVER:
            case ANALYTICS_PAYMENTS_AMEX:
                paymentStatus = find(billing.creditCards.cards, 'status').status;
                break;

            default:
                paymentStatus = ANALYTICS_PAYMENTS_VERIFIED;
        }
        // 4) transactionApproved = yes | no
        paymentStatus = paymentStatus ? paymentStatus.toLowerCase() : ANALYTICS_EMPTY;
        transactionAttributes.transactionApproved =
            paymentStatus === ANALYTICS_PAYMENTS_VERIFIED ? ANALYTICS_YES : ANALYTICS_NO;
    }

    // 5) shippingMethod
    transactionAttributes.shippingMethod = ANALYTICS_EMPTY;
    let deliveryGroups = find(groups, (group) => group.type === 'HOME' || group.type === 'STORE');
    if (!deliveryGroups) {
        deliveryGroups = find(groups, (group) => group.type === 'BOPIS') || {};
    }
    if (deliveryGroups.type === 'BOPIS') {
        transactionAttributes.shippingMethod = ANALYTICS_SHIPPING_METHOD.BOPIS;
    } else {
        const serviceLevels = get(deliveryGroups, 'serviceLevels.data', []);
        const shippingMethod = find(serviceLevels, { selected: true });
        if (shippingMethod) {
            transactionAttributes.shippingMethod = ANALYTICS_SHIPPING_METHOD[shippingMethod.code];
        }
    }

    // 6) bundleFlag = yes | no
    const analyticsAttributes = orderDetails.analyticsAttributes
        ? orderDetails.analyticsAttributes
        : undefined;
    if (!isUndefined(analyticsAttributes)) {
        transactionAttributes.bundleFlag = productHelper.analyticsAttributesMapper(
            analyticsAttributes,
            'largeAppBundleOrder'
        );
    }

    // 7) pricingAccuracyFlag = yes | no | fail
    let priceAccurate = ANALYTICS_NO;
    /* istanbul ignore else */
    if (orderDetails.isPriceAccurate) {
        priceAccurate = ANALYTICS_YES;
    }

    /* istanbul ignore next */
    if (itemAmountObj.length > 0) {
        const itemAmountZero =
            find(itemAmountObj, { amount: 0 }) || find(itemAmountObj, { amount: 0.0 });
        if (itemAmountZero && orderDetails.isPriceAccurate) {
            priceAccurate = ANALYTICS_FAIL;
        }
    }
    transactionAttributes.pricingAccuracyFlag = priceAccurate;
    return transactionAttributes;
};

const createTransactionTotal = (orderDetails) => {
    const transactionTotal = {};

    const findGiftCardTotal = (unnamed) => {
        let total = 0;
        if (unnamed && unnamed.giftCards) {
            each(unnamed.giftCards, (card) => {
                total += card.amount;
            });
        }
        return total;
    };

    const findOrderSubTotal = (totals) => {
        const subTotalAfterAdjustment = find(totals, { type: ANALYTICS_SUBTOTAL_AFTER_ADJUSTMENT });
        if (subTotalAfterAdjustment && subTotalAfterAdjustment.amount) {
            return subTotalAfterAdjustment;
        }
        return find(totals, { type: ANALYTICS_SUB_TOTAL });
    };
    /* istanbul ignore else */
    if (orderDetails) {
        const merchandiseSubTotal = find(orderDetails.totals, { type: ANALYTICS_SUB_TOTAL });
        const orderSubTotal = findOrderSubTotal(orderDetails.totals);
        const orderTotal = find(orderDetails.totals, { type: ANALYTICS_ORDERAMOUNT });
        const shippingCost = find(orderDetails.charges, { type: ANALYTICS_SHIPPING_AND_HANDLING });
        const totalTax = find(orderDetails.charges, { type: ANALYTICS_TAX });
        const overSizedItemSurcharge = find(orderDetails.charges, {
            type: ANALYTICS_OVERSIZESURCHARGE,
        });
        const associateDiscount = find(orderDetails.adjustments, {
            code: ANALYTICS_ASSOCIATEDISCOUNT,
        });
        const roundUpAmount = find(orderDetails.charges, { type: ANALYTICS_ROUNDUP });
        const jcpGiftCardAmount = findGiftCardTotal(orderDetails?.billing?.unnamed);

        transactionTotal.merchandiseSubTotal =
            merchandiseSubTotal && merchandiseSubTotal.amount
                ? merchandiseSubTotal.amount.toFixed(2)
                : ANALYTICS_ZERO;
        transactionTotal.orderSubTotal =
            orderSubTotal && orderSubTotal.amount
                ? Number(orderSubTotal.amount).toFixed(2)
                : ANALYTICS_ZERO;
        transactionTotal.orderTotal =
            orderTotal && orderTotal.amount ? Number(orderTotal.amount).toFixed(2) : ANALYTICS_ZERO;
        transactionTotal.shippingCost =
            shippingCost && shippingCost.amount
                ? Number(shippingCost.amount).toFixed(2)
                : ANALYTICS_ZERO;
        transactionTotal.totalTax =
            totalTax && totalTax.amount ? Number(totalTax.amount).toFixed(2) : ANALYTICS_ZERO;
        transactionTotal.overSizedItemSurcharge =
            overSizedItemSurcharge && overSizedItemSurcharge.amount
                ? Number(overSizedItemSurcharge.amount).toFixed(2)
                : ANALYTICS_ZERO;
        transactionTotal.associateDiscount =
            associateDiscount && associateDiscount.amount
                ? Number(associateDiscount.amount).toFixed(2)
                : ANALYTICS_ZERO;
        transactionTotal.roundUpAmount =
            roundUpAmount && roundUpAmount.amount
                ? Number(roundUpAmount.amount).toFixed(2)
                : ANALYTICS_ZERO;
        transactionTotal.jcpGiftCardAmount = jcpGiftCardAmount
            ? Number(jcpGiftCardAmount).toFixed(2)
            : ANALYTICS_ZERO;
        transactionTotal.giftWrapPrice = ANALYTICS_ZERO;
    }
    return transactionTotal;
};

const jcpDLjcpUpdation = (orderDetails) => {
    /* istanbul ignore else */
    if (window && window.jcpDLjcp) {
        const email = find(orderDetails.contact.methods, { type: 'EMAIL' });
        const trimmedEmail = email ? email.value.trim().toLowerCase() : '';
        const firstName =
            get(orderDetails, 'billing.creditCards.cards[0].address.firstName') ||
            get(orderDetails, 'billing.paypal.address.firstName') ||
            get(orderDetails, 'billing.unnamed.address.firstName') ||
            '';
        const lastName =
            get(orderDetails, 'billing.creditCards.cards[0].address.lastName') ||
            get(orderDetails, 'billing.paypal.address.lastName') ||
            get(orderDetails, 'billing.unnamed.address.lastName') ||
            '';
        const city =
            get(orderDetails, 'billing.creditCards.cards[0].address.city') ||
            get(orderDetails, 'billing.paypal.address.city') ||
            get(orderDetails, 'billing.unnamed.address.city') ||
            '';
        const stateCode =
            get(orderDetails, 'billing.creditCards.cards[0].address.state') ||
            get(orderDetails, 'billing.paypal.address.state') ||
            get(orderDetails, 'billing.unnamed.address.state') ||
            '';
        const zipCode =
            get(orderDetails, 'billing.creditCards.cards[0].address.zip') ||
            get(orderDetails, 'billing.paypal.address.zip') ||
            get(orderDetails, 'billing.unnamed.address.zip') ||
            '';
        const countryCode =
            get(orderDetails, 'billing.creditCards.cards[0].address.country') ||
            get(orderDetails, 'billing.paypal.address.country') ||
            get(orderDetails, 'billing.unnamed.address.country') ||
            '';
        const profileValues = {
            profile: {
                email: trimmedEmail,
                nickname: firstName,
                emailHash: orderDetails.headers ? orderDetails.headers.emailSignature : '',
                normalizedEmailHash: sha256(trimmedEmail),
                srn: lastName,
                ba: {
                    cy: city,
                    st: stateCode,
                    zp: zipCode,
                    ctry: countryCode,
                },
            },
        };
        Object.assign(window.jcpDLjcp, profileValues);
    }
};

// Function which will construct object for selected Store by User
const getSelectedStoreInfo = (store) => {
    let storeData = store.getState().selectedStore
        ? store.getState().selectedStore.storeDetails
        : undefined;
    let selectedStore = '';
    if (isEmpty(storeData)) {
        try {
            storeData = JSON.parse(localStorage.getItem('defaultStore'));
        } catch (e) {
            return null;
        }
    }
    /* istanbul ignore next */
    if (!storeData) {
        return null;
    }
    selectedStore = `${storeData.id}|${storeData.name}|${storeData.distance}|${storeData.isGeoStore}`;
    return selectedStore;
};

const getModifiedCommonDigitalData = (commonDigitalData, store) => {
    const modifiedCommonDigitalData = commonDigitalData;
    // fix for analytics comments
    /* istanbul ignore else */
    if (
        commonDigitalData &&
        commonDigitalData.user &&
        commonDigitalData.user.profile &&
        commonDigitalData.user.profile.profileInfo &&
        commonDigitalData.user.profile.profileInfo.customerState
    ) {
        /* istanbul ignore else */
        if (!User.isUserLoggedIn()) {
            // console.log('guest mode changes');
            modifiedCommonDigitalData.user.profile.profileInfo.rewardsFlag = ANALYTICS_EMPTY;
            modifiedCommonDigitalData.user.profile.profileInfo.rewardsMemberType = ANALYTICS_EMPTY;
            modifiedCommonDigitalData.user.profile.profileInfo.emailOptIn = ANALYTICS_EMPTY;
            modifiedCommonDigitalData.user.profile.profileInfo.profileType = [ANALYTICS_EMPTY];
            modifiedCommonDigitalData.user.profile.profileInfo.expressCheckoutEnabled = ANALYTICS_EMPTY;
            modifiedCommonDigitalData.user.profile.profileInfo.associateFlag = ANALYTICS_EMPTY;
            modifiedCommonDigitalData.user.profile.profileInfo.mobileOptIn = [ANALYTICS_EMPTY];
        } else if (store && User.isUserLoggedIn()) {
            const { productCartridge } = store.getState();
            // in cart page
            let savedItemsCount;
            if (productCartridge && !isEmpty(productCartridge.productCartridgeSlots)) {
                savedItemsCount =
                    productCartridge.productCartridgeSlots.cart_save_for_later &&
                    productCartridge.productCartridgeSlots.cart_save_for_later.itemNumber;
                LocalStorage.setData('SAVED_ITEMS_IN_CART', savedItemsCount);
            } else {
                savedItemsCount = LocalStorage.getData('SAVED_ITEMS_IN_CART');
            }
            // eslint-disable-next-line no-param-reassign
            commonDigitalData.user.profile.profileInfo.itemsInSaveForLater =
                (savedItemsCount && savedItemsCount.toString()) || '0';
        }
    }
    const orderDetails = store?.getState()?.orderDetails?.data || {};
    const {
        billing: { unnamed: { address: { associateCode = 'Inactive' } = {} } = {} } = {},
    } = orderDetails;
    const isAssociate = orderDetails.billing?.creditCards?.cards[0]?.address?.associateCode || '';
    if (toLower(associateCode) === 'active' || toLower(isAssociate) === 'active') {
        modifiedCommonDigitalData.user.profile.profileInfo.associateFlag = 'yes';
    }
    const userSelectedStore = !isEmpty(commonDigitalData.user.profile.profileInfo.storeID)
        ? commonDigitalData.user.profile.profileInfo.storeID
        : store && getSelectedStoreInfo(store);
    if (userSelectedStore) {
        modifiedCommonDigitalData.user.profile.profileInfo.storeID = userSelectedStore.toLowerCase();
    }
    return modifiedCommonDigitalData;
};

const getAuroraDA = (context) => {
    const isAuroraCheck = isAurora();
    const jcpCloudEnv = context && context.preferences && context.preferences.environment;
    const isAuroraDA =
        isAuroraCheck && !isUndefined(jcpCloudEnv) && jcpCloudEnv.indexOf('prod') !== -1
            ? ANALYTICS_YES
            : ANALYTICS_NO;
    return isAuroraDA;
};

const getOCPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);

    const { context } = store.getState();
    let storeOrderDetails = store.getState().orderDetails;

    if (storeOrderDetails && storeOrderDetails.data) {
        storeOrderDetails = storeOrderDetails.data;
    } else {
        return {};
    }
    let applePayOrder = false;
    const paymentCards = get(storeOrderDetails, 'data.billing.creditCards.cards');
    if (paymentCards && paymentCards[0]) {
        applePayOrder = paymentCards[0].applePay;
    }
    const productDL = createProduct(storeOrderDetails, pageName);
    const cartAttributesDL = createCartAttributes(storeOrderDetails, false, applePayOrder);
    const cartRewardsDL = createCardRewards(storeOrderDetails);
    const shippingAddressDL = createShippingAddress(storeOrderDetails);
    const transactionAttributesDL = createTransactionAttributes(storeOrderDetails);
    const createTransactionTotalDL = createTransactionTotal(storeOrderDetails);
    const roundUpAmount = find(storeOrderDetails.charges, { type: 'ROUND UP' });
    cartAttributesDL.checkoutProcessType = getCheckoutProcessType(
        storeOrderDetails,
        modifiedCommonDigitalData
    );
    const commonPageInfo = commonDigitalData.page.pageInfo;
    const ocPageInfo = {
        pageName,
        pageType: ANALYTICS_PAGE_TYPE_CHECKOUT,
        siteSection: ANALYTICS_PAGE_TYPE_CHECKOUT,
        deviceType: productHelper.getDeviceType(context.deviceType),
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        version: ANALYTICS_VERSION_OCP,
        productionCluster: getAuroraDA(context),
    };
    const pageInfo = { ...commonPageInfo, ...ocPageInfo };
    const { expressCheckoutInfo } = store.getState();
    if (expressCheckoutInfo && expressCheckoutInfo.displayExpressCheckout) {
        transactionAttributesDL.shippingExpressCheckoutOpted = 'yes';
    } else {
        transactionAttributesDL.shippingExpressCheckoutOpted = 'no';
    }
    const orderConfirmationPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
                debugSource: commonDigitalData.page.attributes.debugSource,
            },
            category: {
                subCategory2: ANALYTICS_EMPTY,
                subCategory1: ANALYTICS_EMPTY,
                primaryCategory: ANALYTICS_PAGE_TYPE_CHECKOUT,
                department: ANALYTICS_PAGE_TYPE_CHECKOUT,
            },
            pageInfo,
        },
        product: productDL,
        cart: {
            attributes: cartAttributesDL,
            couponRewardsInfo: cartRewardsDL,
        },
        transaction: {
            shiptoaddressorstore: shippingAddressDL,
            total: createTransactionTotalDL,
            attributes: transactionAttributesDL,
        },
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
        user: modifiedCommonDigitalData.user,
    };
    if (!isEmpty(roundUpAmount)) {
        orderConfirmationPageDL.transaction.roundUpAmount = roundUpAmount.amount;
    }
    // Bazaar voice pixel - Bryan request - BEGIN
    jcpDLjcpUpdation(storeOrderDetails);
    // Bazaar voice pixel - Bryan request - END
    return orderConfirmationPageDL;
};

const getCartPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);

    const { context } = store.getState();
    const { isDesktop } = context.deviceType;
    const storeCartDetails = store.getState().cartDetails;
    const isEmptyCart = store.getState().loadEmptyCart;
    const qtyChangedItems = store.getState().quantityChangedItems;
    const orderDataAvailable = !isEmpty(storeCartDetails) && storeCartDetails.data;
    const { plccDynamicBanner } = store.getState();
    const { orderInfo } = store.getState();

    if (!orderDataAvailable && !isEmptyCart) {
        return {};
    }

    const productDL = orderDataAvailable
        ? createProduct(storeCartDetails.data, pageName, qtyChangedItems, isDesktop)
        : productHelper.productDLSkeleton();
    const cartAttributesDL = orderDataAvailable
        ? createCartAttributes(storeCartDetails.data, true, storeCartDetails.applePayEligible)
        : productHelper.cartAttributesDLSkeleton(orderInfo);
    const cartRewardsDL = orderDataAvailable
        ? createCardRewards(storeCartDetails.data)
        : productHelper.couponRewardsInfoDLSkeleton();
    updateCartAttributWithPlccBanner(cartAttributesDL, plccDynamicBanner);
    orderDataAvailable && addSingleClickCheckout(cartAttributesDL, orderDataAvailable, context);
    const commonPageInfo = commonDigitalData.page.pageInfo;
    const cartPageInfo = {
        pageName: ANALYTICS_PAGE_NAME_CHECKOUT_SHOPPING_CART,
        pageType: ANALYTICS_PAGE_TYPE_CHECKOUT,
        siteSection: ANALYTICS_PAGE_TYPE_CHECKOUT,
        deviceType: productHelper.getDeviceType(context.deviceType),
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        version: isEmptyCart ? ANALYTICS_VERSION_EMPTY_CART : ANALYTICS_VERSION_CART,
        productionCluster: getAuroraDA(context),
    };
    const pageInfo = { ...commonPageInfo, ...cartPageInfo };
    const cartPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
                debugSource: commonDigitalData.page.attributes.debugSource,
            },
            category: {
                subCategory2: ANALYTICS_EMPTY,
                subCategory1: ANALYTICS_EMPTY,
                primaryCategory: ANALYTICS_PAGE_TYPE_SHOPPING_CART,
                department: ANALYTICS_PAGE_TYPE_SHOPPING_CART,
            },
            pageInfo,
        },
        product: productDL,
        cart: {
            attributes: cartAttributesDL,
            couponRewardsInfo: cartRewardsDL,
        },
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
        user: modifiedCommonDigitalData.user,
    };
    return cartPageDL;
};

const getSingleClickCheckoutPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);
    const { context } = store.getState();
    const storeCartDetails = store.getState().cartDetails;
    /* istanbul ignore else */
    if (!storeCartDetails || !storeCartDetails.data) {
        return {};
    }
    const productDL = createProduct(storeCartDetails.data, pageName);
    const cartAttributesDL = createCartAttributes(
        storeCartDetails.data,
        true,
        storeCartDetails.applePayEligible
    );
    const cartRewardsDL = createCardRewards(storeCartDetails.data);
    if (pageName !== ANALYTICS_CO_PROCESS_TYPE_PAYPAL_EXPRESS) {
        const scc = true;
        cartAttributesDL.checkoutProcessType = getCheckoutProcessType(
            storeCartDetails.data,
            modifiedCommonDigitalData,
            scc
        );
        storeCartDetails &&
            addSingleClickCheckout(cartAttributesDL, storeCartDetails.data, context);
        const { expressCheckoutInfo } = store.getState();
        if (expressCheckoutInfo && expressCheckoutInfo.displayExpressCheckout) {
            cartAttributesDL.shippingExpressCheckoutDisplayed = 'yes';
        }
    } else {
        cartAttributesDL.checkoutProcessType = ANALYTICS_CO_PROCESS_TYPE_PAYPAL;
    }
    const commonPageInfo = commonDigitalData.page.pageInfo;
    const sccPageInfo = {
        pageName,
        pageType: ANALYTICS_PAGE_TYPE_CHECKOUT,
        siteSection: ANALYTICS_PAGE_TYPE_CHECKOUT,
        deviceType: productHelper.getDeviceType(context.deviceType),
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        version: ANALYTICS_VERSION_SINGLE_CLICK_CHECKOUT,
        productionCluster: getAuroraDA(context),
    };
    const pageInfo = { ...commonPageInfo, ...sccPageInfo };
    const sccPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
                debugSource: commonDigitalData.page.attributes.debugSource,
            },
            category: {
                subCategory2: ANALYTICS_EMPTY,
                subCategory1: ANALYTICS_EMPTY,
                primaryCategory: ANALYTICS_PAGE_TYPE_CHECKOUT,
                department: ANALYTICS_PAGE_TYPE_CHECKOUT,
            },
            pageInfo,
        },
        product: productDL,
        cart: {
            attributes: cartAttributesDL,
            couponRewardsInfo: cartRewardsDL,
        },
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
        user: modifiedCommonDigitalData.user,
    };
    return sccPageDL;
};

const getGiftcardPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);
    // Update captcha type in debugSource for GC balance page
    let gcDebugSource = modifiedCommonDigitalData.page.attributes.debugSource;
    try {
        const giftCardCaptchaType = store.getState().giftCard.captchaType;
        let captchaAttribute = giftCardCaptchaType;
        if (giftCardCaptchaType === 'visible') {
            captchaAttribute = 'v2recaptcha';
        }
        gcDebugSource = [
            ...commonDigitalData.page.attributes.debugSource,
            `captcha=${captchaAttribute}`,
        ];
    } catch (err) {
        // default captcha type is V2Recaptcha
        gcDebugSource = [...commonDigitalData.page.attributes.debugSource, 'captcha=v2recaptcha'];
    }
    const { context } = store.getState();
    const commonPageInfo = commonDigitalData.page.pageInfo;
    const giftCardPageInfo = {
        deviceType: productHelper.getDeviceType(context.deviceType),
        pageName,
        pageType: ANALYTICS_PAGE_TYPE_ACCOUNT,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        siteSection: ANALYTICS_PAGE_TYPE_ACCOUNT,
        version: ANALYTICS_VERSION_GC_BALANCE,
    };
    const pageInfo = { ...commonPageInfo, ...giftCardPageInfo };
    const giftcardPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                debugSource: gcDebugSource,
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
            },
            category: {
                department: ANALYTICS_PAGE_TYPE_ACCOUNT,
                primaryCategory: ANALYTICS_PAGE_TYPE_ACCOUNT,
            },
            pageInfo,
        },
        user: modifiedCommonDigitalData.user,
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
    };
    return giftcardPageDL;
};

const getCheckoutPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);
    const { context } = store.getState();
    const { orderDetails } = store.getState();

    if (!orderDetails || !orderDetails.data) {
        return {};
    }

    const productDL = createProduct(orderDetails?.data, pageName);
    const cartAttributesDL = createCartAttributes(
        orderDetails.data,
        true,
        orderDetails.applePayEligible
    );
    const cartRewardsDL = createCardRewards(orderDetails?.data);
    const { billing } = orderDetails;
    const checkoutPath = find(orderDetails.analyticsAttributes, { type: 'CheckoutPath' });
    const isApplePayOnOrder =
        billing &&
        billing?.creditCards &&
        billing.creditCards.cards &&
        billing?.creditCards?.cards?.length > 0 &&
        !isEmpty(billing.creditCards.cards[0].applePay);
    if ((checkoutPath && checkoutPath.value !== 'PayPal') || !isApplePayOnOrder) {
        cartAttributesDL.checkoutProcessType = getCheckoutProcessType(
            orderDetails.data,
            modifiedCommonDigitalData
        );
    }
    const commonPageInfo = commonDigitalData.page.pageInfo;
    const versionPageNameMap = {};
    versionPageNameMap[ANALYTICS_PAGE_NAME_CHECKOUT_SHIPPING] = ANALYTICS_VERSION_SHIPPING;
    versionPageNameMap[ANALYTICS_PAGE_NAME_CHECKOUT_SAME_DAY_PICKUP] = ANALYTICS_VERSION_SDPU;
    versionPageNameMap[ANALYTICS_PAGE_NAME_CHECKOUT_PAYMENT] = ANALYTICS_VERSION_PAYMENT;
    const checkoutPageInfo = {
        pageName,
        pageType: ANALYTICS_PAGE_TYPE_CHECKOUT,
        siteSection: ANALYTICS_PAGE_TYPE_CHECKOUT,
        deviceType: productHelper.getDeviceType(context.deviceType),
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        version: versionPageNameMap[pageName],
        productionCluster: getAuroraDA(context),
    };
    const pageInfo = { ...commonPageInfo, ...checkoutPageInfo };
    pageInfo.newCheckoutExperienceEnabled = 'yes';
    const checkoutPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
                debugSource: commonDigitalData.page.attributes.debugSource,
            },
            category: {
                subCategory2: ANALYTICS_EMPTY,
                subCategory1: ANALYTICS_EMPTY,
                primaryCategory: ANALYTICS_PAGE_TYPE_CHECKOUT,
                department: ANALYTICS_PAGE_TYPE_CHECKOUT,
            },
            pageInfo,
        },
        product: productDL,
        cart: {
            attributes: cartAttributesDL,
            couponRewardsInfo: cartRewardsDL,
        },
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
        user: modifiedCommonDigitalData.user,
    };
    return checkoutPageDL;
};

const getSignInPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);

    const { context } = store.getState();
    const storeCartDetails = store.getState().cartDetails;

    if (!storeCartDetails || !storeCartDetails.data) {
        return {};
    }

    const productDL = createProduct(storeCartDetails.data, pageName);
    const cartAttributesDL = createCartAttributes(
        storeCartDetails.data,
        true,
        storeCartDetails.applePayEligible
    );
    const cartRewardsDL = createCardRewards(storeCartDetails.data);

    const commonPageInfo = commonDigitalData.page.pageInfo;
    const signInPageInfo = {
        pageName,
        pageType: ANALYTICS_PAGE_TYPE_CHECKOUT,
        siteSection: ANALYTICS_PAGE_TYPE_CHECKOUT,
        deviceType: productHelper.getDeviceType(context.deviceType),
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        version: ANALYTICS_VERSION_CHECKOUT_SIGN,
        productionCluster: getAuroraDA(context),
    };
    const pageInfo = { ...commonPageInfo, ...signInPageInfo };

    const signInPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
                debugSource: commonDigitalData.page.attributes.debugSource,
            },
            category: {
                subCategory2: ANALYTICS_EMPTY,
                subCategory1: ANALYTICS_EMPTY,
                primaryCategory: ANALYTICS_PAGE_TYPE_CHECKOUT,
                department: ANALYTICS_PAGE_TYPE_CHECKOUT,
            },
            pageInfo,
        },
        product: productDL,
        cart: {
            attributes: cartAttributesDL,
            couponRewardsInfo: cartRewardsDL,
        },
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
        user: modifiedCommonDigitalData.user,
    };
    return signInPageDL;
};

const getReviewPageDL = (store, commonDigitalData, pageName) => {
    const modifiedCommonDigitalData = getModifiedCommonDigitalData(commonDigitalData, store);

    const { context } = store.getState();
    const storeCartDetails = store.getState().orderDetails;

    if (!storeCartDetails || !storeCartDetails.data) {
        return {};
    }

    const productDL = createProduct(storeCartDetails.data, pageName);
    const cartAttributesDL = createCartAttributes(
        storeCartDetails.data,
        true,
        storeCartDetails.applePayEligible
    );
    const cartRewardsDL = createCardRewards(storeCartDetails.data);
    cartAttributesDL.checkoutProcessType = getCheckoutProcessType(
        storeCartDetails.data,
        modifiedCommonDigitalData
    );
    const { expressCheckoutInfo } = store.getState();
    /* istanbul ignore else */
    if (expressCheckoutInfo && expressCheckoutInfo.displayExpressCheckout) {
        cartAttributesDL.shippingExpressCheckoutDisplayed = 'yes';
    }
    const commonPageInfo = commonDigitalData.page.pageInfo;
    const reviewPageInfo = {
        pageName,
        pageType: ANALYTICS_PAGE_TYPE_CHECKOUT,
        siteSection: ANALYTICS_PAGE_TYPE_CHECKOUT,
        deviceType: productHelper.getDeviceType(context.deviceType),
        searchRedirect: getURLParameterUsingkey('redirectTerm') || ANALYTICS_EMPTY,
        releaseVersion: context.__RELEASEVERSION__, // eslint-disable-line
        version: ANALYTICS_VERSION_REVIEW,
        productionCluster: getAuroraDA(context),
    };
    const pageInfo = { ...commonPageInfo, ...reviewPageInfo };

    const reviewPageDL = {
        isReady: true,
        dataVersion: commonDigitalData.dataVersion,
        page: {
            attributes: {
                internalCampaignID: commonDigitalData.page.attributes.internalCampaignID,
                debugSource: commonDigitalData.page.attributes.debugSource,
            },
            category: {
                subCategory2: ANALYTICS_EMPTY,
                subCategory1: ANALYTICS_EMPTY,
                primaryCategory: ANALYTICS_PAGE_TYPE_CHECKOUT,
                department: ANALYTICS_PAGE_TYPE_CHECKOUT,
            },
            pageInfo,
        },
        product: productDL,
        cart: {
            attributes: cartAttributesDL,
            couponRewardsInfo: cartRewardsDL,
        },
        error: [
            {
                errorID: ANALYTICS_EMPTY,
                errorDescription: ANALYTICS_EMPTY,
                errorSKU: ANALYTICS_EMPTY,
            },
        ],
        user: modifiedCommonDigitalData.user,
    };
    return reviewPageDL;
};

const getPageDL = (store, commonDigitalData, pageName) => {
    let pageDL;
    switch (pageName) {
        case 'cart':
            pageDL = getCartPageDL(store, commonDigitalData, pageName);
            break;

        case 'single click checkout':
        case 'paypal express':
            pageDL = getSingleClickCheckoutPageDL(store, commonDigitalData, pageName);
            break;

        case 'gift card balance landing':
        case 'gift card balance success':
            pageDL = getGiftcardPageDL(store, commonDigitalData, pageName);
            break;

        case 'checkout login':
        case 'checkout reset password':
        case 'checkout reset triggered':
            pageDL = getSignInPageDL(store, commonDigitalData, pageName);
            break;

        case 'checkout same day pickup':
        case 'checkout shipping':
        case 'checkout payment':
            pageDL = getCheckoutPageDL(store, commonDigitalData, pageName);
            break;

        case 'checkout review':
            pageDL = getReviewPageDL(store, commonDigitalData, pageName);
            break;

        case 'pending order confirmation':
        case 'checkout order confirmation':
            pageDL = getOCPageDL(store, commonDigitalData, pageName);
            break;

        default:
            // eslint-disable-next-line no-console
            console.log('default getPageDL');
            pageDL = {};
    }
    return pageDL;
};

const getCreateAccountDL = () => {
    const commonDigitalData = getModifiedCommonDigitalData(updateCommonDigitalData());
    return {
        user: commonDigitalData.user,
    };
};

const getSelectSameDayPickupDL = (store, skus = []) => {
    const storeCartDetails = cloneDeep(store.getState().cartDetails);
    if (!storeCartDetails || !storeCartDetails.data) {
        return {};
    }
    const SDPUSelectedItems = [];
    each(storeCartDetails.data.bag.items, (item) => {
        if (skus.includes(item.sku.id)) {
            SDPUSelectedItems.push(item);
        }
    });

    storeCartDetails.data.bag.items = SDPUSelectedItems;

    const productDL = createProduct(storeCartDetails.data, 'sameDayPickup');

    return {
        product: productDL,
    };
};

const getGiftCartAddDL = (store, sku) => {
    const storeCartDetails = store.getState().cartDetails;
    if (!storeCartDetails || !storeCartDetails.data) {
        return {};
    }
    const selectedItem = [];
    each(storeCartDetails.data.bag.items, (item) => {
        if (item.sku.id === sku) {
            selectedItem.push(item);
        }
    });
    storeCartDetails.data.bag.items = selectedItem;
    const productDL = createProduct(storeCartDetails.data, 'cartAdd', '', '', '', 'gc banner');

    return {
        product: productDL,
    };
};

const getModifiedCCActionDA = (actionType) => ({
    page: {
        pageInfo: {
            eventAction: actionType,
        },
    },
});

// on click of Apply coupon, trigger this function
const getCouponRewardInfo = (store) => {
    const { cartDetails } = store.getState();
    const analyticsAttributes =
        cartDetails && cartDetails.data && cartDetails.data.analyticsAttributes;
    const couponStore = store.getState().coAppliedAdjustments;
    const appliedCouponInfo = couponStore && { ...couponStore.lastTouchedAdjustment };
    LocalStorage.setData('lastTouchedAdjustment', appliedCouponInfo);
    const bestCouponObj = find(store.getState().coCoupons.groups, { id: 'BESTCOUPONS' });
    const bestCouponApplied =
        bestCouponObj &&
        bestCouponObj.coupons &&
        appliedCouponInfo &&
        appliedCouponInfo.value &&
        find(bestCouponObj.coupons, { code: appliedCouponInfo.value });
    /* istanbul ignore else */
    if (appliedCouponInfo.method === 'manual' && appliedCouponInfo.code !== ANALYTICS_REWARDSCERT) {
        appliedCouponInfo.value = `${appliedCouponInfo.value}${ANALYTICS_BOF}`;
    } else if (appliedCouponInfo.code !== ANALYTICS_REWARDSCERT) {
        appliedCouponInfo.value = bestCouponApplied
            ? `${appliedCouponInfo.value}${ANALYTICS_BEST_COUPON}${ANALYTICS_BOF}`
            : `${appliedCouponInfo.value}${ANALYTICS_BOF}`;
    }

    const orderDetails = {
        adjustments: [],
        analyticsAttributes,
    };
    orderDetails.adjustments.push(appliedCouponInfo);
    const couponRewardsInfo = createCardRewards(orderDetails);
    // create a cart obj(an obj of an array), that's how DA wants it
    return {
        cart: {
            couponRewardsInfo,
        },
    };
};

const getCartItemUpdateDL = (store, clickType) => {
    const storeOrderItems =
        store.getState().orderItems ||
        (store.getState().addToCartInterstitialDetails &&
            store.getState().addToCartInterstitialDetails.bag.items);
    const addToCartInterstitialDetailsItems = get(
        store.getState(),
        'addToCartInterstitialDetails.bag.items',
        []
    );
    let cartDetails;
    if (!storeOrderItems) {
        return null;
    }
    let productDL = {};
    let findItem = '';
    const params = {
        isOC: false,
    };
    const analyticsEventData = store.getState().analyticsPageLevelData;
    let { productId } = (analyticsEventData || {}).cartUpdate || {};
    switch (clickType) {
        case ANALYTICS_ACTIONS_UPDATE_CART:
        case ANALYTICS_ACTIONS_REMOVE_ITEM: {
            findItem =
                analyticsEventData && analyticsEventData.cartUpdate
                    ? find(storeOrderItems, { id: analyticsEventData.cartUpdate.productId })
                    : undefined;
            const childItems = get(findItem, 'childItems', []);
            findItem =
                !isEmpty(childItems) && analyticsEventData.cartUpdate.serviceType
                    ? find(childItems, { type: analyticsEventData.cartUpdate.serviceType })
                    : findItem;
            productDL = findItem ? productHelper.mediumObjFactory(findItem, params) : {};
            if (!isEmpty(productDL) && findItem) {
                const qtyChangedItems = store.getState().quantityChangedItems;
                productDL.productPrevQuantity = analyticsEventData.cartUpdate.productPrevQuantity
                    ? String(analyticsEventData.cartUpdate.productPrevQuantity)
                    : '1';
                productDL.productMaxQuantityReached = productHelper.isProductMaxQuantityReached(
                    findItem
                );
                const childItemquantity =
                    !isEmpty(childItems) && get(findItem, 'sku.quantity', '0');
                productDL.productQuantity = childItemquantity
                    ? String(childItemquantity)
                    : productDL.productQuantity;
                productDL.productAutoQuantityDowngraded = includes(qtyChangedItems, findItem.id)
                    ? ANALYTICS_YES
                    : ANALYTICS_NO;
                productDL.productEstimatedDelivery = productHelper.productEstimatedDelivery(
                    findItem.deliveryOptions
                );
                clickType === ANALYTICS_ACTIONS_REMOVE_ITEM && (productDL.productQuantity = '0');
            }
            break;
        }
        case ANALYTICS_ACTIONS_INTERSTITIAL_UPDATE_CART:
            productDL = productHelper.mediumObjFactory(storeOrderItems, params);
            break;
        case ANALYTICS_ACTIONS_OPTIONAL_SERVICE_REMOVE_CART: {
            const {
                cartUpdate: { RemovedChildItems = null },
            } = analyticsEventData;
            findItem =
                analyticsEventData && analyticsEventData.cartUpdate
                    ? find(addToCartInterstitialDetailsItems, {
                          id: analyticsEventData.cartUpdate.productId,
                      })
                    : undefined;
            const phelper = RemovedChildItems
                ? productHelper.mediumObjFactory(RemovedChildItems, params)
                : {};
            const RemovedChildItemsQuantity = get(RemovedChildItems, 'sku.quantity', '0');
            phelper.productQuantity = RemovedChildItemsQuantity
                ? String(RemovedChildItemsQuantity)
                : phelper.productQuantity;
            productDL = RemovedChildItems
                ? { ...phelper, productQuantity: '0', productPrevQuantity: phelper.productQuantity }
                : phelper;
            break;
        }
        case ANALYTICS_ACTIONS_OPTIONAL_SERVICE_UPDATE_CART:
        case ANALYTICS_ACTIONS_OPTIONAL_SERVICE_ADD_CART: {
            const {
                cartUpdate: { RemovedChildItems: alreadyAddedChildItems = null },
            } = analyticsEventData;
            findItem =
                analyticsEventData && analyticsEventData.cartUpdate
                    ? find(addToCartInterstitialDetailsItems, {
                          id: analyticsEventData.cartUpdate.productId,
                      })
                    : undefined;
            const childItems =
                findItem && findItem.childItems
                    ? find(findItem.childItems, { type: analyticsEventData.cartUpdate.serviceType })
                    : undefined;
            const phelper = childItems ? productHelper.mediumObjFactory(childItems, params) : {};
            const childItemquantity = !isEmpty(childItems) && get(childItems, 'sku.quantity', '0');
            phelper.productQuantity = childItemquantity
                ? String(childItemquantity)
                : phelper.productQuantity;
            // Adding a new service type then ADD_CART
            productDL =
                clickType === ANALYTICS_ACTIONS_OPTIONAL_SERVICE_ADD_CART
                    ? { ...phelper, clickPosition: 'add to cart|cart|options' }
                    : phelper;
            productDL = alreadyAddedChildItems
                ? { ...productDL, productPrevQuantity: '0' }
                : productDL;

            break;
        }
        case ANALYTICS_ACTIONS_SAVE_FOR_LATER:
            if (!productId) {
                productId = ((analyticsEventData || {}).sflItem || {}).itemId;
            }
            findItem = productId ? find(storeOrderItems, { id: productId }) : undefined;
            productDL = findItem ? productHelper.mediumObjFactory(findItem, params) : {};
            productDL.productEstimatedDelivery =
                !isEmpty(productDL) && findItem
                    ? productHelper.productEstimatedDelivery(findItem.deliveryOptions)
                    : ANALYTICS_EMPTY;
            break;

        case ANALYTICS_ACTIONS_MOVE_TO_CART:
            cartDetails = store.getState().cartDetails;
            findItem = find(
                cartDetails.data.bag.items,
                (item) => item.sku.id === analyticsEventData
            );
            productDL = findItem ? productHelper.mediumObjFactory(findItem, params) : {};
            productDL.productEstimatedDelivery = !isEmpty(productDL)
                ? productHelper.productEstimatedDelivery(findItem.deliveryOptions)
                : ANALYTICS_EMPTY;
            break;
        default:
            productDL = {};
            break;
    }
    return {
        product: [{ productInfo: productDL }],
    };
};

const getOOSProductsDL = (store) => {
    const orderDetails = store.getState().orderDetails || store.getState().cartDetails;
    /* istanbul ignore next */
    if (!orderDetails || !orderDetails.data) {
        return {};
    }

    const items =
        orderDetails.data.bag && orderDetails.data.bag.items
            ? orderDetails.data.bag.items
            : undefined;
    /* istanbul ignore next */
    if (isUndefined(items)) {
        return {};
    }
    const oosItems = filter(items, (item) => isOOSItem(item));
    const params = {
        okToDifferenciateSTS: false,
    };

    const productInfoArray = [];

    each(oosItems, (item) => {
        const product = { productInfo: productHelper.mediumObjFactory(item, params) };
        productInfoArray.push(product);
    });

    const oosProductsDL = {
        product: productInfoArray,
    };

    return oosProductsDL;
};

const getCaptchaError = (payload) => {
    let type;
    if (payload.pageInfo === ANALYTICS_PAGE_INFO_CART) {
        type = ANALYTICS_PAGE_INFO_PAGE_TYPE_CART;
    } else if (payload.pageInfo === ANALYTICS_PAGE_INFO_CHECKOUT) {
        type = ANALYTICS_PAGE_INFO_PAGE_TYPE_CHECKOUT;
    }
    return {
        page: {
            pageInfo: {
                captchaMessageCode: type,
            },
        },
    };
};

const clickHandler = (store, clickType) => {
    let storeOrderDetails = '';
    const dlHandler = {
        digitalData: {},
        analyticsEventName: '',
    };
    if (typeof clickType === 'string') {
        switch (clickType) {
            case ANALYTICS_ACTIONS_CREATE_ACCOUNT:
            case ANALYTICS_ACTIONS_LINK_REWARDS_ACCOUNT:
                dlHandler.digitalData = getCreateAccountDL();
                delete dlHandler.digitalData.user.profile.profileInfo.storeID;
                delete dlHandler.digitalData.user.profile.profileInfo.itemsInSaveForLater;
                break;
            case ANALYTICS_ACTIONS_UPDATE_CART:
            case ANALYTICS_ACTIONS_REMOVE_ITEM:
            case ANALYTICS_ACTIONS_MOVE_TO_CART:
            case ANALYTICS_ACTIONS_SAVE_FOR_LATER:
            case ANALYTICS_ACTIONS_OPTIONAL_SERVICE_UPDATE_CART:
            case ANALYTICS_ACTIONS_OPTIONAL_SERVICE_REMOVE_CART:
            case ANALYTICS_ACTIONS_OPTIONAL_SERVICE_ADD_CART:
                dlHandler.digitalData = getCartItemUpdateDL(store, clickType);
                break;
            case ANALYTICS_ACTIONS_COUPON_APPLIED_SUCCESS:
                dlHandler.digitalData = getCouponRewardInfo(store);
                break;
            case ANALYTICS_ACTIONS_SELECT_STORE_SUCCESS:
                dlHandler.digitalData = getSelectedStoreInfo(store);
                break;
            case ANALYTICS_ACTIONS_INTERSTITIAL_UPDATE_CART:
                storeOrderDetails = store.getState().addToCartInterstitialDetails;
                dlHandler.digitalData = {
                    product: createProduct(storeOrderDetails, 'insterstitalCartUpdate'),
                };
                break;
            case ANALYTICS_ACTIONS_SAME_DAY_PICKUP:
                dlHandler.digitalData = getSelectSameDayPickupDL(store);
                break;
            case ANALYTICS_ACTIONS_EXPRESS_CHECKOUT:
            case ANALYTICS_ACTIONS_EXPEDITED_CHECKOUT:
                dlHandler.digitalData = {};
                break;
            case ANALYTICS_ACTIONS_PRODUCT_CO_OOS:
                dlHandler.digitalData = getOOSProductsDL(store);
                break;
            case ANALYTICS_ACTIONS_LOGIN_ATTEMPTED:
            case ANALYTICS_ACTIONS_LOGIN_FAILED:
                dlHandler.digitalData = {};
                break;
            case ANALYTICS_ACTIONS_EDIT_CARD_AT_CHECKOUT:
                dlHandler.digitalData = getModifiedCCActionDA('edit');
                break;
            case ANALYTICS_ACTIONS_DELETE_CARD_AT_CHECKOUT:
                dlHandler.digitalData = getModifiedCCActionDA('delete');
                break;
            default:
                // eslint-disable-next-line no-console
                console.log('ANALYTICS default click event type', clickType);
                break;
        }
        dlHandler.analyticsEventName = ANALYTICS_EVENTS[clickType];
    } /* istanbul ignore else */ else if (clickType !== undefined) {
        switch (clickType.name) {
            case ANALYTICS_ACTIONS_SAME_DAY_PICKUP:
                dlHandler.digitalData = getSelectSameDayPickupDL(store, clickType.skus);
                break;
            case ANALYTICS_ACTIONS_CAPTCHA_ERROR:
                dlHandler.digitalData = getCaptchaError(clickType);
                break;

            case ANALYTICS_ACTIONS_CART_ADD:
                dlHandler.digitalData = getGiftCartAddDL(store, clickType.skuId);
                dlHandler.digitalData.productFindingMethod = 'up sell';
                break;
            case ANALYTICS_ACTIONS_COUPON_REMOVED:
                dlHandler.digitalData = clickType.couponObj;
                break;
            default:
                // eslint-disable-next-line no-console
                console.log('ANALYTICS default click event type', clickType);
                break;
        }
        dlHandler.analyticsEventName = ANALYTICS_EVENTS[clickType.name];
    }
    return dlHandler;
};

const pushPlccBannerData = (plccBannerName) => ({
    cart: {
        attributes: {
            plccBannerName,
        },
    },
});

class CheckoutActionFilter extends BaseActionFilter {
    constructor() {
        super();
        updateCommonDigitalData = this.updateCommonDigitalData;
        getURLParameterUsingkey = this.getURLParameterBykey;
        this.getPageDL = getPageDL;
        this.clickHandler = clickHandler;
        this.pushPlccBannerData = pushPlccBannerData;
    }
}

export default CheckoutActionFilter;
